import React, {Component} from "react";
import ReactModal from 'react-modal';
import { connect } from "react-redux";
import { saveLogin } from "../../redux/actions/loginActions";
import { fetchUser } from "../../redux/actions/userActions";

import {
  Grommet,
  Box,
  Header,
  Sidebar,
  Footer,
  Heading,
  Paragraph,
  Text,
  Anchor, 
  Button, 
  CheckBox,
  Form,
  FormField,
  TextInput,
  RadioButtonGroup,
  RangeInput,
  Select,
  TextArea,
  Collapsible,
  Nav,
  Carousel,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
  Icons,
  Grid,
  Tabs,
  Tab,
  DataTable,
  Avatar,
  Layer,
  Stack,
  Drop,
  DropButton,
  ResponsiveContext, 
} from 'grommet';
import { Menu, FormClose, Notification, User, Cart, Mail, Contact, StatusGoodSmall, FormAdd, FormSubtract, Trash } from 'grommet-icons';

import { Config } from '../../Config';
import { apiconn } from '../../apiconn'; //axios connectors are here

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var size = '';

class MainFooter extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      width: 0,
      height: 0,
    }
    
    size = this.props.size;
    
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    
  }
  
  componentDidMount(){
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  renderFooterMenu(){
    return (
      <>
      <Box fill="horizontal" flex="false">
        <Box className="container" pad={{vertical:"50px"}}>
          <Grid
            fill="horizontal"
            rows={['min-content']}
            columns={size !== 'small' ? '20%' : '100%'}
            gap={size !== 'small' ? '50px' : '20px'}
          >
            <Box>
              <Image className="footer-logo" src="logo.png" />
            </Box>
            <Box gap="10px">
              <Heading level="4" margin="none">Our Services</Heading>
              <Anchor href="/about-us" size="small" label="About Us" />
              <Anchor href="/articles" size="small" label="Blogs" />
              <Anchor href="/faq" size="small" label="FAQ" />
            </Box>
            <Box gap="10px">
              <Heading level="4" margin="none">Shop</Heading>
              <Anchor href="/products" size="small" label="Our Products" />
              <Anchor href="/my-account" size="small" label="My Account" />
              <Anchor href="/confirm-payment" size="small" label="Payment Confirmation" />
            </Box>
            <Box gap="10px">
              <Heading level="4" margin="none">Contact</Heading>
              <Text size="small">Contact Us</Text>
              <Box direction="row" gap="10px">
                <Box width="30px" height="30px">
                  <Anchor href="#">
                    <Image src="icon-instagram.png" fit="contain" fill />
                  </Anchor>
                </Box>
                <Box width="30px" height="30px">
                  <Anchor href="#">
                    <Image src="icon-facebook.png" fit="contain" fill />
                  </Anchor>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Box>
        <Box className="copyright">
          <Text size="small">BCH &copy; 2022 All rights reserved</Text>
        </Box>
      </Box>
      </>
    )
  }

  
  render(){
    return (
      <>
        { /* {( size !== 'small') ? ( */}
        {this.state.width > 960 ? (
          <Footer className="page-footer">
            {this.renderFooterMenu()}
          </Footer>
        ): (
          <Footer className="page-footer">
            <Box className="container">
              {this.renderFooterMenu()}
            </Box>
          </Footer>
        )}
      </>
    )
  }
}
  
const mapStateToProps = (state, ownProps) => {
  return {
    login: state.loginData,
    user: state.userData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveLogin: (id_user, api_token) => {
      dispatch(saveLogin(id_user, api_token));
    },
    fetchUser: userdata => {
      dispatch(fetchUser(userdata));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainFooter); 
